export const speakerData = {
  fullRangeGeneral: [
    {
      productImage: "./images/speakers/productImages/F02104D0.png",
      model: "F02104D0",
      size: "39 mm",
      sizeInch: "1.5inch",
      impedance: "4 ohm",
      nominalPower: "4 W",
      maximumPower: "5 W",
      resonantFrequency: "200 Hz",
      frequencyRange: "fo ~20k Hz",
      soundPressureLevel: "84 dB",
      voiceCoilDiameter: "16 mm",
      magnetMass: "21.5 g (0.75oz)",
      totalMass: "68 g",
      externals: {
        cone: "Aluminum / Silver",
        surround: "PU / Black",
        gasket: "PAPER / Black",
        terminal: "Solder Lug",
      },
    },
    {
      productImage: "./images/speakers/productImages/F02105D0.png",
      model: "F02105D0",
      size: "50 mm",
      sizeInch: "2inch",
      impedance: "4 ohm",
      nominalPower: "2 W",
      maximumPower: "3 W",
      resonantFrequency: "200 Hz",
      frequencyRange: "fo ~20k Hz",
      soundPressureLevel: "82 dB",
      voiceCoilDiameter: "19 mm",
      magnetMass: "7.6 g (0.27oz)",
      totalMass: "35 g",
      externals: {
        cone: "Paper / Black",
        surround: "Cloth / Black",
        gasket: "Paper / Black",
        dustCap: "Paper / Black",
        terminal: "Solder Lug",
      },
    },
    {
      productImage: "./images/speakers/productImages/F02205H0.png",
      model: "F02205H0",
      size: "50 mm",
      sizeInch: "2inch",
      impedance: "8 ohm",
      nominalPower: "5 W",
      maximumPower: "7 W",
      resonantFrequency: "300 Hz",
      frequencyRange: "fo ~15k Hz",
      soundPressureLevel: "84 dB",
      voiceCoilDiameter: "14 mm",
      magnetMass: "47.4 g (1.67oz)",
      totalMass: "133 g",
      externals: {
        cone: "Paper / Black",
        surround: "Cloth / Black",
        gasket: "Paper / Black",
        dustCap: "Paper / Black",
        terminal: "Solder Lug",
      },
    },
    {
      productImage: "./images/speakers/productImages/F01405H0.png",
      model: "F01405H0",
      size: "50 mm",
      sizeInch: "2inch",
      impedance: "8 ohm",
      nominalPower: "5 W",
      maximumPower: "7 W",
      resonantFrequency: "210 Hz",
      frequencyRange: "fo ~20k Hz",
      soundPressureLevel: "83 dB",
      voiceCoilDiameter: "14 mm",
      magnetMass: "44.7 g (1.58oz)",
      totalMass: "128 g",
      externals: {
        cone: "Paper / Paper",
        surround: "Cloth / Black",
        gasket: "Paper / Black",
        dustCap: "Paper / Black",
        terminal: "Solder Lug",
      },
    },
    {
      productImage: "./images/speakers/productImages/F03406H0.png",
      model: "F03406H0",
      size: "57 mm",
      sizeInch: "2.25inch",
      impedance: "8 ohm",
      nominalPower: "10 W",
      maximumPower: "12 W",
      resonantFrequency: "180 Hz",
      frequencyRange: "fo ~20k Hz",
      soundPressureLevel: "83 dB",
      voiceCoilDiameter: "16 mm",
      magnetMass: "57.7 g (2.04oz)",
      totalMass: "172 g",
      externals: {
        cone: "Paper / Black",
        surround: "Cloth / Black",
        gasket: "Paper / Black",
        dustCap: "Paper / Black",
        terminal: "110 series",
      },
    },
    {
      productImage: "./images/speakers/productImages/F02506H0.png",
      model: "F02506H0",
      size: "57 mm",
      sizeInch: "2.25inch",
      impedance: "8 ohm",
      nominalPower: "10 W",
      maximumPower: "12 W",
      resonantFrequency: "190 Hz",
      frequencyRange: "fo ~15k Hz",
      soundPressureLevel: "82 dB",
      voiceCoilDiameter: "20 mm",
      magnetMass: "51.9 g (1.83oz)",
      totalMass: "220 g",
      externals: {
        cone: "Paper / Black",
        surround: "Cloth / Black",
        gasket: "Paper / Black",
        dustCap: "Cloth / Black",
        terminal: "110 series",
      },
    },
    {
      productImage: "./images/speakers/productImages/F00207H0.png",
      model: "F00207H0",
      size: "66 mm",
      sizeInch: "2.6inch",
      impedance: "8 ohm",
      nominalPower: "2 W",
      maximumPower: "4 W",
      resonantFrequency: "400 Hz",
      frequencyRange: "fo ~15k Hz",
      soundPressureLevel: "89 dB",
      voiceCoilDiameter: "13 mm",
      magnetMass: "47.6 g (1.68oz)",
      totalMass: "125 g",
      externals: {
        cone: "Paper / Black",
        surround: "Paper / Black",
        gasket: "Paper / Black",
        dustCap: "PET / Black",
        terminal: "Solder Lug",
      },
    },
    {
      productImage: "./images/speakers/productImages/F00407D0.png",
      model: "F00407D0",
      size: "66 mm",
      sizeInch: "2.6inch",
      impedance: "4 ohm",
      nominalPower: "4 W",
      maximumPower: "5 W",
      resonantFrequency: "580 Hz",
      frequencyRange: "fo ~7k Hz",
      soundPressureLevel: "87 dB",
      voiceCoilDiameter: "13 mm",
      magnetMass: "34.3 g (1.21oz)",
      totalMass: "95 g",
      externals: {
        cone: "PET / Clear",
        surround: "PET / Clear",
        gasket: "Paper / Black",
        dustCap: "PET / Clear",
        terminal: "Solder Lug",
      },
    },
    {
      productImage: "./images/speakers/productImages/F01207H0.png",
      model: "F01207H0",
      size: "66 mm",
      sizeInch: "2.6inch",
      impedance: "8 ohm",
      nominalPower: "5 W",
      maximumPower: "7 W",
      resonantFrequency: "180 Hz",
      frequencyRange: "fo ~20k Hz",
      soundPressureLevel: "87 dB",
      voiceCoilDiameter: "14 mm",
      magnetMass: "62 g (2.19oz)",
      totalMass: "178 g",
      externals: {
        cone: "Paper / Purple",
        surround: "Cloth / Black",
        gasket: "Paper / Black",
        dustCap: "Paper / Black",
        terminal: "110 series",
      },
    },
    {
      productImage: "./images/speakers/productImages/F01607H0.png",
      model: "F01607H0",
      size: "66 mm",
      sizeInch: "2.6inch",
      impedance: "8 ohm",
      nominalPower: "5 W",
      maximumPower: "7 W",
      resonantFrequency: "250 Hz",
      frequencyRange: "fo ~20k Hz",
      soundPressureLevel: "87 dB",
      voiceCoilDiameter: "14 mm",
      magnetMass: "38.1 g (1.34oz)",
      totalMass: "176 g",
      externals: {
        cone: "Paper / Black",
        surround: "Cloth / Black",
        gasket: "Paper / Black",
        dustCap: "Paper / Black",
        terminal: "Solder Lug",
      },
    },
    {
      productImage: "./images/speakers/productImages/F02407H0.png",
      model: "F02407H0",
      size: "66 mm",
      sizeInch: "2.6inch",
      impedance: "8 ohm",
      nominalPower: "5 W",
      maximumPower: "7 W",
      resonantFrequency: "250 Hz",
      frequencyRange: "fo ~20k Hz",
      soundPressureLevel: "87 dB",
      voiceCoilDiameter: "14 mm",
      magnetMass: "47.4 g (1.67oz)",
      totalMass: "140 g",
      externals: {
        cone: "Paper / Black",
        surround: "Cloth / Black",
        gasket: "Paper / Black",
        dustCap: "Paper / Black",
        terminal: "Solder Lug",
      },
    },
    {
      productImage: "./images/speakers/productImages/F02907H0.png",
      model: "F02907H0",
      size: "66 mm",
      sizeInch: "2.6inch",
      impedance: "8 ohm",
      nominalPower: "10 W",
      maximumPower: "12 W",
      resonantFrequency: "170 Hz",
      frequencyRange: "fo ~20k Hz",
      soundPressureLevel: "85 dB",
      voiceCoilDiameter: "25 mm",
      magnetMass: "22.8 g (0.80oz)",
      totalMass: "160 g",
      externals: {
        cone: "Paper / Black",
        surround: "Rubber / Black",
        dustCap: "Paper / Black",
        terminal: "+ 205 - 110 series",
      },
    },
    {
      productImage: "./images/speakers/productImages/F03907H0.png",
      model: "F03907H0",
      size: "66 mm",
      sizeInch: "2.6inch",
      impedance: "8 ohm",
      nominalPower: "10 W",
      maximumPower: "12 W",
      resonantFrequency: "220 Hz",
      frequencyRange: "fo ~20k Hz",
      soundPressureLevel: "81 dB",
      voiceCoilDiameter: "20 mm",
      magnetMass: "41.5 g (1.46oz)",
      totalMass: "200 g",
      externals: {
        cone: "Paper / Black",
        surround: "Cloth / Black",
        dustCap: "Paper / Black",
        terminal: "110 series",
      },
    },
    {
      productImage: "./images/speakers/productImages/F00408H0.png",
      model: "F00408H0",
      size: "77 mm",
      sizeInch: "3inch",
      impedance: "8 ohm",
      nominalPower: "5 W",
      maximumPower: "7.5 W",
      resonantFrequency: "145 Hz",
      frequencyRange: "fo ~20k Hz",
      soundPressureLevel: "81 dB",
      voiceCoilDiameter: "13 mm",
      magnetMass: "34.3 g (1.21oz)",
      totalMass: "120 g",
      externals: {
        cone: "Paper / Black",
        surround: "Cloth / Black",
        gasket: "Paper / Black",
        dustCap: "Paper / Black",
        terminal: "+ 205 - 110 series",
      },
    },
    {
      productImage: "./images/speakers/productImages/F01408H0.png",
      model: "F01408H0",
      size: "77 mm",
      sizeInch: "3inch",
      impedance: "8 ohm",
      nominalPower: "2 W",
      maximumPower: "3 W",
      resonantFrequency: "200 Hz",
      frequencyRange: "fo ~20k Hz",
      soundPressureLevel: "88 dB",
      voiceCoilDiameter: "13 mm",
      magnetMass: "16.2 g (0.57oz)",
      totalMass: "108 g",
      externals: {
        cone: "Paper / Black",
        surround: "Paper / Black",
        gasket: "Paper / Black",
        dustCap: "Paper / Black",
        terminal: "110 series",
      },
    },
    {
      productImage: "./images/speakers/productImages/F01908H0.png",
      model: "F01908H0",
      size: "77 mm",
      sizeInch: "3inch",
      impedance: "8 ohm",
      nominalPower: "10 W",
      maximumPower: "15 W",
      resonantFrequency: "170 Hz",
      frequencyRange: "fo ~20k Hz",
      soundPressureLevel: "87 dB",
      voiceCoilDiameter: "16 mm",
      magnetMass: "101.2 g (3.57oz)",
      totalMass: "280 g",
      externals: {
        cone: "Paper / Black",
        surround: "Cloth / Black",
        gasket: "Paper / Black",
        dustCap: "Paper / Black",
        terminal: "110 series",
      },
    },
    {
      productImage: "./images/speakers/productImages/F02108H0.png",
      model: "F02108H0",
      size: "77 mm",
      sizeInch: "3inch",
      impedance: "8 ohm",
      nominalPower: "10 W",
      maximumPower: "15 W",
      resonantFrequency: "130 Hz",
      frequencyRange: "fo ~20k Hz",
      soundPressureLevel: "85 dB",
      voiceCoilDiameter: "16 mm",
      magnetMass: "101.2 g (3.57oz)",
      totalMass: "260 g",
      externals: {
        cone: "Paper / Black",
        surround: "Rubber / Black",
        gasket: "Paper / Black",
        dustCap: "Paper / Black",
        terminal: "110 series",
      },
    },
    {
      productImage: "./images/speakers/productImages/F02208H0.png",
      model: "F02208H0",
      size: "77 mm",
      sizeInch: "3inch",
      impedance: "8 ohm",
      nominalPower: "5 W",
      maximumPower: "7.5 W",
      resonantFrequency: "180 Hz",
      frequencyRange: "fo ~20k Hz",
      soundPressureLevel: "84 dB",
      voiceCoilDiameter: "13 mm",
      magnetMass: "16.2 g (0.57oz)",
      totalMass: "112 g",
      externals: {
        cone: "Paper / Black",
        surround: "Cloth / Black",
        gasket: "Paper / Black",
        dustCap: "PEI / Black",
        terminal: "Solder Lug",
      },
    },
    {
      productImage: "./images/speakers/productImages/F02408H0.png",
      model: "F02408H0",
      size: "77 mm",
      sizeInch: "3inch",
      impedance: "8 ohm",
      nominalPower: "10 W",
      maximumPower: "15 W",
      resonantFrequency: "130 Hz",
      frequencyRange: "fo ~20k Hz",
      soundPressureLevel: "83 dB",
      voiceCoilDiameter: "20 mm",
      magnetMass: "81.3 g (2.87oz)",
      totalMass: "380 g",
      externals: {
        cone: "Paper / Black",
        surround: "Cloth / Black",
        gasket: "Paper / Black",
        dustCap: "Paper / Black",
        terminal: "110 series",
      },
    },
    {
      productImage: "./images/speakers/productImages/F02608H0.png",
      model: "F02608H0",
      size: "77 mm",
      sizeInch: "3inch",
      impedance: "8 ohm",
      nominalPower: "10 W",
      maximumPower: "15 W",
      resonantFrequency: "120 Hz",
      frequencyRange: "fo ~20k Hz",
      soundPressureLevel: "86 dB",
      voiceCoilDiameter: "16 mm",
      magnetMass: "101.2 g (3.57oz)",
      totalMass: "385 g",
      externals: {
        cone: "Paper / Black",
        surround: "Rubber / Black",
        gasket: "Paper / Black",
        dustCap: "Paper / Black",
        terminal: "+ 205 - 110 series",
      },
    },
    {
      productImage: "./images/speakers/productImages/F05208H0.png",
      model: "F05208H0",
      size: "77 mm",
      sizeInch: "3inch",
      impedance: "8 ohm",
      nominalPower: "8 W",
      maximumPower: "12 W",
      resonantFrequency: "300 Hz",
      frequencyRange: "fo ~20k Hz",
      soundPressureLevel: "83 dB",
      voiceCoilDiameter: "20 mm",
      magnetMass: "8.1 g (0.29oz)",
      totalMass: "60 g",
      externals: {
        cone: "Paper / Black",
        surround: "Cloth / Black",
        gasket: "Paper / Black",
        dustCap: "Paper / Black",
        terminal: "Solder Lug",
      },
    },
    {
      productImage: "./images/speakers/productImages/F01109H0.png",
      model: "F01109H0",
      size: "90 mm",
      sizeInch: "3.5inch",
      impedance: "8 ohm",
      nominalPower: "15 W",
      maximumPower: "20 W",
      resonantFrequency: "160 Hz",
      frequencyRange: "fo ~20k Hz",
      soundPressureLevel: "88 dB",
      voiceCoilDiameter: "20 mm",
      magnetMass: "123.1 g (4.34oz)",
      totalMass: "530 g",
      externals: {
        cone: "Paper / Black",
        surround: "Cloth / Black",
        gasket: "Paper / Black",
        dustCap: "Paper / Black",
        terminal: "110 series",
      },
    },
    {
      productImage: "./images/speakers/productImages/F00210D1.png",
      model: "F00210D1",
      size: "100 mm",
      sizeInch: "4inch",
      impedance: "4 ohm",
      nominalPower: "15 W",
      maximumPower: "30 W",
      resonantFrequency: "110 Hz",
      frequencyRange: "fo ~20k Hz",
      soundPressureLevel: "86 dB",
      voiceCoilDiameter: "20 mm",
      magnetMass: "123.5 g (4.36oz)",
      totalMass: "375 g",
      externals: {
        cone: "Paper / Black",
        surround: "Cloth / Black",
        gasket: "Paper / Black",
        dustCap: "Paper / Black",
        terminal: "+ 205 - 110 series",
      },
    },
    {
      productImage: "./images/speakers/productImages/F02410H0.png",
      model: "F02410H0",
      size: "100 mm",
      sizeInch: "4inch",
      impedance: "8 ohm",
      nominalPower: "30 W",
      maximumPower: "40 W",
      resonantFrequency: "135 Hz",
      frequencyRange: "fo ~10k Hz",
      soundPressureLevel: "87 dB",
      voiceCoilDiameter: "25 mm",
      magnetMass: "149 g (5.26oz)",
      totalMass: "456 g",
      externals: {
        cone: "Paper / Black",
        surround: "Cloth / Black",
        gasket: "Paper / Black",
        dustCap: "Cloth / Black",
        terminal: "+ 205 - 110 series",
      },
    },
    {
      productImage: "./images/speakers/productImages/F02710H0.png",
      model: "F02710H0",
      size: "100 mm",
      sizeInch: "4inch",
      impedance: "8 ohm",
      nominalPower: "10 W",
      maximumPower: "15 W",
      resonantFrequency: "110 Hz",
      frequencyRange: "fo ~20k Hz",
      soundPressureLevel: "87 dB",
      voiceCoilDiameter: "20 mm",
      magnetMass: "17 g (0.6oz)",
      totalMass: "130 g",
      externals: {
        cone: "Paper / Black",
        surround: "Cloth / Black",
        gasket: "Paper / Black",
        dustCap: "PET / Black",
        terminal: "+ 205 - 110 series",
      },
    },
    {
      productImage: "./images/speakers/productImages/F03310H0.png",
      model: "F03310H0",
      size: "100 mm",
      sizeInch: "4inch",
      impedance: "8 ohm",
      nominalPower: "15 W",
      maximumPower: "20 W",
      resonantFrequency: "100 Hz",
      frequencyRange: "fo ~16k Hz",
      soundPressureLevel: "86 dB",
      voiceCoilDiameter: "20 mm",
      magnetMass: "149.1 g (5.26oz)",
      totalMass: "440 g",
      externals: {
        cone: "Paper / Black",
        surround: "Rubber / Black",
        gasket: "Paper / Black",
        dustCap: "Paper / Black",
        terminal: "+ 205 - 110 series",
      },
    },
    {
      productImage: "./images/speakers/productImages/F03910H0.png",
      model: "F03910H0",
      size: "100 mm",
      sizeInch: "4inch",
      impedance: "8 ohm",
      nominalPower: "30 W",
      maximumPower: "45 W",
      resonantFrequency: "120 Hz",
      frequencyRange: "fo ~20k Hz",
      soundPressureLevel: "88 dB",
      voiceCoilDiameter: "25 mm",
      magnetMass: "123.1 g (0.57oz)",
      totalMass: "551 g",
      externals: {
        cone: "Paper / Black",
        surround: "Cloth / Black",
        gasket: "Paper / Black",
        dustCap: "Paper / Black",
        terminal: "+ 205 - 110 series",
      },
    },
    {
      productImage: "./images/speakers/productImages/F00212H1.png",
      model: "F00212H1",
      size: "120 mm",
      sizeInch: "5inch",
      impedance: "8 ohm",
      nominalPower: "3 W",
      maximumPower: "5 W",
      resonantFrequency: "160 Hz",
      frequencyRange: "fo ~1.5k Hz",
      soundPressureLevel: "90 dB",
      voiceCoilDiameter: "14 mm",
      magnetMass: "41.5 g (1.46oz)",
      totalMass: "160 g",
      externals: {
        cone: "Paper / Black",
        surround: "Paper / Black",
        gasket: "Paper / Black",
        dustCap: "Cloth / Black",
        terminal: "110 series",
      },
    },
    {
      productImage: "./images/speakers/productImages/F00812C0.png",
      model: "F00812C0",
      size: "120 mm",
      sizeInch: "5inch",
      impedance: "3 ohm",
      nominalPower: "6 W",
      maximumPower: "10 W",
      resonantFrequency: "120 Hz",
      frequencyRange: "fo ~15k Hz",
      soundPressureLevel: "89 dB",
      voiceCoilDiameter: "16 mm",
      magnetMass: "79.5 g (2.80oz)",
      totalMass: "290 g",
      externals: {
        cone: "Paper / Black",
        surround: "Cloth / Black",
        gasket: "Paper / Black",
        dustCap: "PET / Black",
        terminal: "110 series",
      },
    },
    {
      productImage: "./images/speakers/productImages/F02712H0.png",
      model: "F02712H0",
      size: "120 mm",
      sizeInch: "5inch",
      impedance: "8 ohm",
      nominalPower: "40 W",
      maximumPower: "50 W",
      resonantFrequency: "90 Hz",
      frequencyRange: "fo ~10k Hz",
      soundPressureLevel: "85 dB",
      voiceCoilDiameter: "16 mm",
      magnetMass: "240 g (8.47oz)",
      totalMass: "683 g",
      externals: {
        cone: "Paper / Black",
        surround: "Rubber / Black",
        gasket: "Paper / Black",
        dustCap: "Paper / Black",
        terminal: "+ 205 - 110 series",
      },
    },
    {
      productImage: "./images/speakers/productImages/F00213D0.png",
      model: "F00213D0",
      size: "130 mm",
      sizeInch: "5.25inch",
      impedance: "4 ohm",
      nominalPower: "25 W",
      maximumPower: "50 W",
      resonantFrequency: "90 Hz",
      frequencyRange: "fo ~20k Hz",
      soundPressureLevel: "90 dB",
      voiceCoilDiameter: "25 mm",
      magnetMass: "177 g (6.24oz)",
      totalMass: "580 g",
      externals: {
        cone: "Paper / Black",
        subCone: "Paper / Black",
        surround: "Urethane / Gray",
        gasket: "Paper / Black",
        dustCap: "PET / Silver",
        terminal: "+ 205 - 110 series",
      },
    },
    {
      productImage: "./images/speakers/productImages/C00513D0.png",
      model: "C00513D0",
      size: "130 mm",
      sizeInch: "5.25inch",
      impedance: "4 ohm",
      nominalPower: "20 W",
      maximumPower: "40 W",
      resonantFrequency: "100 Hz",
      frequencyRange: "fo ~20k Hz",
      soundPressureLevel: "85 dB",
      voiceCoilDiameter: "25 mm",
      magnetMass: "276.9 g (9.77oz)",
      totalMass: "1000 g",
      externals: {
        cone: "PP / White",
        surround: "Rubber / Black",
        gasket: "Paper / Black",
        tweeter: "Ti Balanced Type",
        terminal: "+ 205 - 110 series",
      },
    },
    {
      productImage: "./images/speakers/productImages/C00716D0.png",
      model: "C00716D0",
      size: "160 mm",
      sizeInch: "6.5inch",
      impedance: "4 ohm",
      nominalPower: "15 W",
      maximumPower: "25 W",
      resonantFrequency: "40 Hz",
      frequencyRange: "fo ~20k Hz",
      soundPressureLevel: "85 dB",
      voiceCoilDiameter: "25 mm",
      magnetMass: "276.9 g (9.77oz)",
      totalMass: "900 g",
      externals: {
        cone: "Paper / Black",
        surround: "Rubber / Black",
        gasket: "Paper / Black",
        tweeter: "Ti Balanced Type",
        terminal: "+ 205 - 110 series",
      },
    },
    {
      productImage: "./images/speakers/productImages/F00116H1.png",
      model: "F00116H1",
      size: "160 mm",
      sizeInch: "6.5inch",
      impedance: "8 ohm",
      nominalPower: "20 W",
      maximumPower: "40 W",
      resonantFrequency: "95 Hz",
      frequencyRange: "fo ~15k Hz",
      soundPressureLevel: "90 dB",
      voiceCoilDiameter: "20 mm",
      magnetMass: "154 g (5.43oz)",
      totalMass: "480 g",
      externals: {
        cone: "Paper / Black",
        surround: "Cloth / Black",
        gasket: "Paper / Black",
        dustCap: "Paper / Black",
        terminal: "+ 205 - 110 series",
      },
    },
  ],
  fullRangeOval: [
    {
      productImage: "./images/speakers/productImages/F02607D0.png",
      model: "F02607D0",
      size: "70x40 mm",
      sizeInch: "2.75x1.6inch",
      impedance: "4 ohm",
      nominalPower: "5 W",
      maximumPower: "10 W",
      resonantFrequency: "360 Hz",
      frequencyRange: "fo ~20k Hz",
      soundPressureLevel: "84 dB",
      voiceCoilDiameter: "13 mm",
      magnetMass: "2.5 g (0.09oz)",
      totalMass: "34 g",
      externals: {
        cone: "Paper / Black",
        surround: "Cloth / Black",
        gasket: "Paper / Black",
        dustCap: "Paper / Black",
        terminal: "Solder Lug",
      },
    },
    {
      productImage: "./images/speakers/productImages/F02707H0.png",
      model: "F02707H0",
      size: "70x40 mm",
      sizeInch: "2.75x1.6inch",
      impedance: "8 ohm",
      nominalPower: "4 W",
      maximumPower: "5 W",
      resonantFrequency: "600 Hz",
      frequencyRange: "fo ~20k Hz",
      soundPressureLevel: "82 dB",
      voiceCoilDiameter: "13 mm",
      magnetMass: "2.5 g (0.09oz)",
      totalMass: "35 g",
      externals: {
        cone: "PET / Clear",
        surround: "PET / Clear",
        gasket: "Paper / Black",
        dustCap: "PET / Clear",
        terminal: "Solder Lug",
      },
    },
    {
      productImage: "./images/speakers/productImages/M00207H0.png",
      model: "M00207H0",
      size: "70x30 mm",
      sizeInch: "2.75x1.2inch",
      impedance: "8 ohm",
      nominalPower: "8 W",
      maximumPower: "10 W",
      resonantFrequency: "500 Hz",
      frequencyRange: "fo ~20k Hz",
      soundPressureLevel: "83 dB",
      voiceCoilDiameter: "13 mm",
      magnetMass: "3.4 g (0.12oz)",
      totalMass: "42 g",
      externals: {
        cone: "Paper / Black",
        surround: "Cloth / Black",
        gasket: "Paper / Black",
        dustCap: "Paper / Black",
        terminal: "Connector",
      },
    },
    {
      productImage: "./images/speakers/productImages/F00809D0.png",
      model: "F00809D0",
      size: "90x50 mm",
      sizeInch: "3.5x2inch",
      impedance: "4 ohm",
      nominalPower: "10 W",
      maximumPower: "15 W",
      resonantFrequency: "220 Hz",
      frequencyRange: "fo ~20k Hz",
      soundPressureLevel: "82 dB",
      voiceCoilDiameter: "14 mm",
      magnetMass: "8 g (0.28oz)",
      totalMass: "73 g",
      externals: {
        cone: "Paper / Black",
        surround: "Cloth / Black",
        gasket: "Paper / Black",
        dustCap: "Paper / Black",
        terminal: "+ 205 - 110 series",
      },
    },
    {
      productImage: "./images/speakers/productImages/F00110F0.png",
      model: "F00110F0",
      size: "100x30 mm",
      sizeInch: "4x1.2inch",
      impedance: "6 ohm",
      nominalPower: "3.5 W",
      maximumPower: "5.5 W",
      resonantFrequency: "200 Hz",
      frequencyRange: "fo ~5k Hz",
      soundPressureLevel: "81 dB",
      voiceCoilDiameter: "14 mm",
      magnetMass: "20.8 g (0.73oz)",
      totalMass: "82 g",
      externals: {
        cone: "Paper / Black",
        surround: "Cloth / Black",
        gasket: "Paper / Black",
        dustCap: "Paper / Black",
        terminal: "+ 205 - 110 series",
      },
    },
    {
      productImage: "./images/speakers/productImages/F01912D0.png",
      model: "F01912D0",
      size: "120x80 mm",
      sizeInch: "5x3inch",
      impedance: "4 ohm",
      nominalPower: "10 W",
      maximumPower: "12 W",
      resonantFrequency: "130 Hz",
      frequencyRange: "fo ~20k Hz",
      soundPressureLevel: "86 dB",
      voiceCoilDiameter: "16 mm",
      magnetMass: "47.4 g (1.67oz)",
      totalMass: "200 g",
      externals: {
        cone: "Paper / Black",
        surround: "Cloth / Black",
        gasket: "Paper / Black",
        dustCap: "Paper / Black",
        terminal: "+ 205 - 110 series",
      },
    },
    {
      productImage: "./images/speakers/productImages/F02112H0.png",
      model: "F02112H0",
      size: "120x50 mm",
      sizeInch: "5x2inch",
      impedance: "8 ohm",
      nominalPower: "10 W",
      maximumPower: "12 W",
      resonantFrequency: "140 Hz",
      frequencyRange: "fo ~8.5k Hz",
      soundPressureLevel: "85 dB",
      voiceCoilDiameter: "16 mm",
      magnetMass: "30.5 g (1.08oz)",
      totalMass: "250 g",
      externals: {
        cone: "Paper / Black",
        surround: "Rubber / Black",
        gasket: "Paper / Black",
        dustCap: "Paper / Black",
        terminal: "+ 205 - 110 series",
      },
    },
    {
      productImage: "./images/speakers/productImages/F01612H0.png",
      model: "F01612H0",
      size: "120x80 mm",
      sizeInch: "5x3inch",
      impedance: "8 ohm",
      nominalPower: "10 W",
      maximumPower: "15 W",
      resonantFrequency: "135 Hz",
      frequencyRange: "fo ~20k Hz",
      soundPressureLevel: "87 dB",
      voiceCoilDiameter: "16 mm",
      magnetMass: "122.9 g (4.34oz)",
      totalMass: "323 g",
      externals: {
        cone: "Paper / Black",
        surround: "Cloth / Black",
        gasket: "Paper / Black",
        dustCap: "Paper / Black",
        terminal: "110 series",
      },
    },
    {
      productImage: "./images/speakers/productImages/F00115F0.png",
      model: "F00115F0",
      size: "150x60 mm",
      sizeInch: "6x2inch",
      impedance: "6 ohm",
      nominalPower: "15 W",
      maximumPower: "20 W",
      resonantFrequency: "130 Hz",
      frequencyRange: "fo ~20k Hz",
      soundPressureLevel: "90 dB",
      voiceCoilDiameter: "16 mm",
      magnetMass: "90.4 g (3.19oz)",
      totalMass: "420 g",
      externals: {
        cone: "Paper / Black",
        surround: "Cloth / Black",
        dustCap: "Paper / Black",
        terminal: "+ 205 - 110 series",
      },
    },
    {
      productImage: "./images/speakers/productImages/F02212H0.png",
      model: "F02212H0",
      size: "120x60 mm",
      sizeInch: "5x2.4inch",
      impedance: "8 ohm",
      nominalPower: "10 W",
      maximumPower: "12 W",
      resonantFrequency: "120 Hz",
      frequencyRange: "fo ~10k Hz",
      soundPressureLevel: "85 dB",
      voiceCoilDiameter: "16 mm",
      magnetMass: "112.3 g (3.96oz)",
      totalMass: "350 g",
      externals: {
        cone: "Paper / Black",
        surround: "Rubber / Black",
        gasket: "Paper / Black",
        dustCap: "Paper / Black",
        terminal: "+ 205 - 110 series",
      },
    },
    {
      productImage: "./images/speakers/productImages/F01309H0.png",
      model: "F01309H0",
      size: "140x100x100 mm",
      sizeInch: "",
      impedance: "8 ohm",
      nominalPower: "10 W",
      maximumPower: "15 W",
      resonantFrequency: "170 Hz",
      frequencyRange: "fo ~20k Hz",
      soundPressureLevel: "87 dB",
      voiceCoilDiameter: "16 mm",
      magnetMass: "77.5 g (2.74oz)",
      totalMass: "194 g",
      externals: {
        cone: "Paper / Black",
        surround: "Rubber / Black",
        gasket: "Rubber / Black",
        dustCap: "Paper / Black",
        terminal: "Connector",
      },
    },
  ],
  tweeters: [
    {
      productImage: "./images/speakers/productImages/T00403D1.png",
      model: "T00403D1",
      size: "25 mm",
      sizeInch: "1inch",
      impedance: "3.2 ohm",
      nominalPower: "20 W",
      maximumPower: "",
      resonantFrequency: "",
      frequencyRange: "5k ~20k Hz",
      soundPressureLevel: "87 dB",
      voiceCoilDiameter: "13 mm",
      magnetMass: "20.8 g (0.73oz)",
      totalMass: "58 g",
      externals: {
        facePlate: "ABS / Black",
        diaphragm: "Ti / Silver",
        network: "w/NETWORK",
        base: "ABS / Black",
        terminal: "110 series",
      },
    },
    {
      productImage: "./images/speakers/productImages/T01303H1.png",
      model: "T01303H1",
      size: "25 mm",
      sizeInch: "1inch",
      impedance: "8 ohm",
      nominalPower: "20 W",
      maximumPower: "",
      resonantFrequency: "",
      frequencyRange: "3k ~20k Hz",
      soundPressureLevel: "88 dB",
      voiceCoilDiameter: "11 mm",
      magnetMass: "20.8 g (0.73oz)",
      totalMass: "65 g",
      externals: {
        facePlate: "ABS / Black",
        diaphragm: "PEI / Black",
        network: "w/NETWORK",
        base: "ABS / Black",
        terminal: "+ 205 - 110 series",
      },
    },
    {
      productImage: "./images/speakers/productImages/T01703F0.png",
      model: "T01703F0",
      size: "25 mm",
      sizeInch: "1inch",
      impedance: "6 ohm",
      nominalPower: "30 W",
      maximumPower: "",
      resonantFrequency: "",
      frequencyRange: "2k ~20k Hz",
      soundPressureLevel: "89 dB",
      voiceCoilDiameter: "25 mm",
      magnetMass: "99.1 g (3.5oz)",
      totalMass: "405 g",
      externals: {
        facePlate: "ABS / Black",
        diaphragm: "Tetoron / Black",
        network: "w/NETWORK",
        terminal: "205 series",
      },
    },
    {
      productImage: "./images/speakers/productImages/F00805H0.png",
      model: "F00805H0",
      size: "50 mm",
      sizeInch: "2inch",
      impedance: "8 ohm",
      nominalPower: "8 W",
      maximumPower: "",
      resonantFrequency: "",
      frequencyRange: "2k ~20k Hz",
      soundPressureLevel: "87 dB",
      voiceCoilDiameter: "13 mm",
      magnetMass: "25.8 g (0.91oz)",
      totalMass: "100 g",
      externals: {
        cone: "Paper / Black",
        surround: "Paper / Black",
        gasket: "Paper / Black",
        dustCap: "Paper / Black",
        network: "w/NETWORK",
        terminal: "110 series",
      },
    },
    {
      productImage: "./images/speakers/productImages/T00507H0.png",
      model: "T00507H0",
      size: "70x40 mm",
      sizeInch: "2.75x1.6inch",
      impedance: "8 ohm",
      nominalPower: "10 W",
      maximumPower: "",
      resonantFrequency: "",
      frequencyRange: "1k ~20k Hz",
      soundPressureLevel: "86 dB",
      voiceCoilDiameter: "13 mm",
      magnetMass: "25.8 g (0.91oz)",
      totalMass: "92 g",
      externals: {
        cone: "Paper / Black",
        surround: "Paper / Black",
        gasket: "Paper / Black",
        dustCap: "Paper / Black",
        network: "w/NETWORK",
        terminal: "110 series",
      },
    },
    {
      productImage: "./images/speakers/productImages/T00112H1.png",
      model: "T00112H1",
      size: "77 mm",
      sizeInch: "3inch",
      impedance: "8 ohm",
      nominalPower: "20 W",
      maximumPower: "",
      resonantFrequency: "",
      frequencyRange: "2k ~20k Hz",
      soundPressureLevel: "94 dB",
      voiceCoilDiameter: "13 mm",
      magnetMass: "90.4 g (3.19oz)",
      totalMass: "273 g",
      externals: {
        cone: "Paper / Black",
        surround: "Paper / Black",
        gasket: "Paper / Black",
        dustCap: "Paper / Black",
        network: "w/NETWORK",
        terminal: "110 series",
      },
    },
  ],
  woofers: [
    {
      productImage: "./images/speakers/productImages/F03508F0.png",
      model: "F03508F0",
      size: "77 mm",
      sizeInch: "3inch",
      impedance: "6 ohm",
      nominalPower: "10 W",
      maximumPower: "15 W",
      resonantFrequency: "90 Hz",
      frequencyRange: "fo ~5k Hz",
      soundPressureLevel: "83 dB",
      voiceCoilDiameter: "20 mm",
      magnetMass: "101.2 g (3.57oz)",
      totalMass: "400 g",
      externals: {
        cone: "Paper / Black",
        surround: "Rubber / Black",
        gasket: "Paper / Black",
        dustCap: "Cloth / Black",
        terminal: "110 series",
      },
    },
    {
      productImage: "./images/speakers/productImages/F04510H0.png",
      model: "F04510H0",
      size: "100 mm",
      sizeInch: "4inch",
      impedance: "8 ohm",
      nominalPower: "20 W",
      maximumPower: "30 W",
      resonantFrequency: "100 Hz",
      frequencyRange: "fo ~6k Hz",
      soundPressureLevel: "84 dB",
      voiceCoilDiameter: "25 mm",
      magnetMass: "193.8 g (6.84oz)",
      totalMass: "530 g",
      externals: {
        cone: "Paper / Black",
        surround: "Rubber / Black",
        gasket: "Paper / Black",
        dustCap: "Cloth / Black",
        terminal: "+ 205 - 110 series",
      },
    },
    {
      productImage: "./images/speakers/productImages/W00610H0.png",
      model: "W00610H0",
      size: "100 mm",
      sizeInch: "4inch",
      impedance: "8 ohm x2",
      nominalPower: "25 W x2",
      maximumPower: "40 W",
      resonantFrequency: "60 Hz",
      frequencyRange: "fo ~8k Hz",
      soundPressureLevel: "85 dB",
      voiceCoilDiameter: "16 mm",
      magnetMass: "357.8 g (12.62oz)",
      totalMass: "917 g",
      externals: {
        cone: "Paper / Black",
        surround: "Rubber / Black",
        dustCap: "Paper / Black",
        terminal: "+ 205 - 110 series",
      },
    },
    {
      productImage: "./images/speakers/productImages/W00712D1.png",
      model: "W00712D1",
      size: "120 mm",
      sizeInch: "5inch",
      impedance: "4 ohm",
      nominalPower: "40 W",
      maximumPower: "80 W",
      resonantFrequency: "70 Hz",
      frequencyRange: "fo ~5k Hz",
      soundPressureLevel: "85 dB",
      voiceCoilDiameter: "30 mm",
      magnetMass: "221.6 g (7.82oz)",
      totalMass: "710 g",
      externals: {
        cone: "PP / Black",
        surround: "Rubber / Black",
        gasket: "Paper / Black",
        dustCap: "PP / Black",
        terminal: "+ 205 - 110 series",
      },
    },
    {
      productImage: "./images/speakers/productImages/W01412H0.png",
      model: "W01412H0",
      size: "120 mm",
      sizeInch: "5inch",
      impedance: "8 ohm x2",
      nominalPower: "30 W x2",
      maximumPower: "45 W",
      resonantFrequency: "60 Hz",
      frequencyRange: "fo ~7k Hz",
      soundPressureLevel: "88 dB",
      voiceCoilDiameter: "16 mm",
      magnetMass: "357.8 g (12.62oz)",
      totalMass: "900 g",
      externals: {
        cone: "Paper / Black",
        surround: "Rubber / Black",
        gasket: "Paper / Black",
        dustCap: "Paper / Black",
        terminal: "+ 205 - 110 series",
      },
    },
    {
      productImage: "./images/speakers/productImages/W00816D1.png",
      model: "W00816D1",
      size: "160 mm",
      sizeInch: "6.5inch",
      impedance: "4 ohm",
      nominalPower: "40 W",
      maximumPower: "80 W",
      resonantFrequency: "60 Hz",
      frequencyRange: "fo ~10k Hz",
      soundPressureLevel: "89 dB",
      voiceCoilDiameter: "25 mm",
      magnetMass: "276.9 g (9.77oz)",
      totalMass: "1200 g",
      externals: {
        cone: "Paper / Black",
        surround: "Cloth / Black",
        gasket: "EVA / Black",
        dustCap: "Cloth / Black",
        terminal: "+ 205 - 110 series",
      },
    },
    {
      productImage: "./images/speakers/productImages/W00120D1.png",
      model: "W00120D1",
      size: "200 mm",
      sizeInch: "8inch",
      impedance: "4 ohm",
      nominalPower: "80 W",
      maximumPower: "150 W",
      resonantFrequency: "40 Hz",
      frequencyRange: "fo ~6k Hz",
      soundPressureLevel: "87 dB",
      voiceCoilDiameter: "38 mm",
      magnetMass: "555.8 g (19.61oz)",
      totalMass: "2070 g",
      externals: {
        cone: "Paper / Silver",
        surround: "Urethane / Gray",
        gasket: "Paper / Black",
        dustCap: "Paper / Silver",
        terminal: "+ 205 - 110 series",
      },
    },
    {
      productImage: "./images/speakers/productImages/W01120G1.png",
      model: "W01120G1",
      size: "200 mm",
      sizeInch: "8inch",
      impedance: "7 ohm",
      nominalPower: "100 W",
      maximumPower: "200 W",
      resonantFrequency: "50 Hz",
      frequencyRange: "fo ~3k Hz",
      soundPressureLevel: "92 dB",
      voiceCoilDiameter: "30 mm",
      magnetMass: "433 g (15.27oz)",
      totalMass: "1700 g",
      externals: {
        cone: "Paper / Black",
        surround: "Urethane / Gray",
        gasket: "Paper / Black",
        dustCap: "Paper / Black",
        terminal: "+ 205 - 110 series",
      },
    },
    {
      productImage: "./images/speakers/productImages/W00225D1.png",
      model: "W00225D1",
      size: "250 mm",
      sizeInch: "10inch",
      impedance: "4 ohm",
      nominalPower: "40 W",
      maximumPower: "80 W",
      resonantFrequency: "32 Hz",
      frequencyRange: "fo ~2k Hz",
      soundPressureLevel: "88 dB",
      voiceCoilDiameter: "50 mm",
      magnetMass: "418.5 g (14.76oz)",
      totalMass: "3300 g",
      externals: {
        cone: "Paper / Black",
        surround: "Urethane / Gray",
        dustCap: "PP / Black",
        terminal: "+ 205 - 110 series",
      },
    },
    {
      productImage: "./images/speakers/productImages/W00230D1.png",
      model: "W00230D1",
      size: "300 mm",
      sizeInch: "12inch",
      impedance: "4 ohm",
      nominalPower: "40 W",
      maximumPower: "80 W",
      resonantFrequency: "35 Hz",
      frequencyRange: "fo ~4k Hz",
      soundPressureLevel: "89 dB",
      voiceCoilDiameter: "50 mm",
      magnetMass: "555.8 g (19.61oz)",
      totalMass: "3850 g",
      externals: {
        cone: "Paper / Black",
        surround: "Urethane / Gray",
        dustCap: "PP / Black",
        terminal: "+ 205 - 110 series",
      },
    },
    {
      productImage: "./images/speakers/productImages/W00138H1.png",
      model: "W00138H1",
      size: "380 mm",
      sizeInch: "15inch",
      impedance: "8 ohm",
      nominalPower: "100 W",
      maximumPower: "200 W",
      resonantFrequency: "38 Hz",
      frequencyRange: "fo ~2k Hz",
      soundPressureLevel: "95 dB",
      voiceCoilDiameter: "45 mm",
      magnetMass: "1379.8 g (498.67oz)",
      totalMass: "4600 g",
      externals: {
        cone: "Paper / Black",
        surround: "Cloth / Black",
        gasket: "Paper / Black",
        dustCap: "Paper / Black",
        terminal: "205 series",
      },
    },
  ],
  microSpeakers: [
    {
      productImage: "./images/speakers/productImages/M00302H0.png",
      model: "M00302H0",
      size: "16 mm",
      sizeInch: "",
      impedance: "8 ohm",
      nominalPower: "0.5 W",
      maximumPower: "0.8 W",
      resonantFrequency: "900 Hz",
      frequencyRange: "fo ~20k Hz",
      soundPressureLevel: "72 dB",
      voiceCoilDiameter: "",
      magnetMass: "",
      totalMass: "1.5 g",
      externals: {
        diaphragm: "PET / Black",
        terminal: "PCB",
      },
    },
    {
      productImage: "./images/speakers/productImages/M00202H0.png",
      model: "M00202H0",
      size: "20 mm",
      sizeInch: "",
      impedance: "8 ohm",
      nominalPower: "0.5 W",
      maximumPower: "0.7 W",
      resonantFrequency: "550 Hz",
      frequencyRange: "fo ~6k Hz",
      soundPressureLevel: "77 dB",
      voiceCoilDiameter: "",
      magnetMass: "",
      totalMass: "2.2 g",
      externals: {
        diaphragm: "PET / Black",
        terminal: "PCB",
      },
    },
    {
      productImage: "./images/speakers/productImages/F01203H0.png",
      model: "F01203H0",
      size: "28 mm",
      sizeInch: "",
      impedance: "8 ohm",
      nominalPower: "0.4 W",
      maximumPower: "0.5 W",
      resonantFrequency: "750 Hz",
      frequencyRange: "fo ~7k Hz",
      soundPressureLevel: "88 dB",
      voiceCoilDiameter: "",
      magnetMass: "",
      totalMass: "5.2 g",
      externals: {
        diaphragm: "PET / Black",
        terminal: "PCB",
      },
    },
    {
      productImage: "./images/speakers/productImages/M00204H0.png",
      model: "M00204H0",
      size: "40 mm",
      sizeInch: "",
      impedance: "8 ohm",
      nominalPower: "0.5 W",
      maximumPower: "0.7 W",
      resonantFrequency: "600 Hz",
      frequencyRange: "fo ~6k Hz",
      soundPressureLevel: "82 dB",
      voiceCoilDiameter: "",
      magnetMass: "",
      totalMass: "9 g",
      externals: {
        diaphragm: "PET / Black",
        terminal: "PCB",
      },
    },
    {
      productImage: "./images/speakers/productImages/F02904H0.png",
      model: "F02904H0",
      size: "35x20 mm",
      sizeInch: "",
      impedance: "8 ohm",
      nominalPower: "1 W",
      maximumPower: "1.5 W",
      resonantFrequency: "740 Hz",
      frequencyRange: "fo ~12k Hz",
      soundPressureLevel: "78 dB",
      voiceCoilDiameter: "",
      magnetMass: "",
      totalMass: "6 g",
      externals: {
        cone: "Paper / Black",
        surround: "Cloth / Black",
        dustCap: "Paper / Black",
        terminal: "Solder Lug",
      },
    },
    {
      productImage: "./images/speakers/productImages/F01204H0.png",
      model: "F01204H0",
      size: "40x28 mm",
      sizeInch: "",
      impedance: "8 ohm",
      nominalPower: "2 W",
      maximumPower: "3 W",
      resonantFrequency: "400 Hz",
      frequencyRange: "fo ~20k Hz",
      soundPressureLevel: "79 dB",
      voiceCoilDiameter: "",
      magnetMass: "",
      totalMass: "13 g",
      externals: {
        cone: "Cloth / Black",
        surround: "Cloth / Black",
        dustCap: "Paper / Black",
        terminal: "Solder Lug",
      },
    },
  ],
  speakerSystems: [
    {
      productImage: "./images/speakers/productImages/S00308D0.png",
      model: "S00308D0",
      driveUnit: "77mm Full Range",
      impedance: "4 ohm",
      nominalPower: "10 W",
      maximumPower: "15 W",
      frequencyRange: "200~20 kHz",
      soundPressureLevel: "85 dB",
      dimensions: "120x90x97.5 mm",
      totalMass: "605 g",
      externals: {
        cabinet: "PP / Black",
        grille: "SPCC / Black",
        terminal: "Connector cord",
      },
    },
    {
      productImage: "./images/speakers/productImages/S00110D1.png",
      model: "S00110D1",
      driveUnit: "100mm Full Range",
      impedance: "4 ohm",
      nominalPower: "40 W",
      maximumPower: "60 W",
      frequencyRange: "90~12 kHz",
      soundPressureLevel: "87.5 dB",
      dimensions: "196x138x142 mm",
      totalMass: "1.4 kg",
      externals: {
        cabinet: "PP / Black",
        grille: "SPCC / Black",
        terminal: "Connector cord",
      },
    },
    {
      productImage: "./images/speakers/productImages/S00112D1.png",
      model: "S00112D1",
      driveUnit: "120mm Woofer",
      impedance: "4 ohm",
      nominalPower: "40 W",
      maximumPower: "80 W",
      frequencyRange: "110~5k Hz",
      soundPressureLevel: "82 dB",
      dimensions: "210x81x300 mm",
      totalMass: "2.06 kg",
      externals: {
        cabinet: "ABS / Black",
        grille: "SPCC / Black",
        terminal: "Connector Cord",
      },
    },
    {
      productImage: "./images/speakers/productImages/S00516D1.png",
      model: "S00516D1",
      driveUnit: "160mm Woofer + 25mm Tweeter",
      impedance: "4 ohm",
      nominalPower: "40 W",
      maximumPower: "80 W",
      frequencyRange: "60~20k Hz",
      soundPressureLevel: "88 dB",
      dimensions: "450x207x240 mm",
      totalMass: "5.4 kg",
      externals: {
        cabinet: "MDF + PP / Black",
        grille: "SPCC / Black",
        terminal: "Snap in Terminal",
      },
    },
    {
      productImage: "./images/speakers/productImages/S00120D1.png",
      model: "S00120D1",
      driveUnit: "200mm Woofer",
      impedance: "4 ohm",
      nominalPower: "80 W",
      maximumPower: "150 W",
      frequencyRange: "60~150 Hz",
      soundPressureLevel: "87 dB",
      dimensions: "320x270x295 mm",
      totalMass: "8.9 kg",
      externals: {
        cabinet: "MDF + PP / Black",
        terminal: "Banana Terminal",
      },
    },
  ],
};
